import { useCallback, useEffect, useState } from 'react';

export type Route = { name: 'catalog' } | { name: 'material'; id: string } | { name: 'profile' } | { name: 'certificate'; code: string } | { name: 'verify'; code: string };

export function parse(path: string): Route {
  const m = path.match(/^\/material\/([0-9a-f-]{36})$/i);
  if (m) return { name: 'material', id: m[1]! };
  if (path === '/profile') return { name: 'profile' };
  const c = path.match(/^\/certificate\/(FC-\d{6}-\d{4})$/i);
  if (c) return { name: 'certificate', code: c[1]!.toUpperCase() };
  const v = path.match(/^\/c\/([A-Za-z0-9-]{1,24})$/);
  if (v) return { name: 'verify', code: v[1]!.toUpperCase() };
  return { name: 'catalog' };
}

export function toPath(r: Route): string {
  switch (r.name) {
    case 'material':
      return `/material/${r.id}`;
    case 'profile':
      return '/profile';
    case 'certificate':
      return `/certificate/${r.code}`;
    case 'verify':
      return `/c/${r.code}`;
    default:
      return '/';
  }
}

/** History-backed router: the Telegram back button and the browser back share one stack. */
export function useRouter() {
  const [route, setRoute] = useState<Route>(() => parse(location.pathname));
  useEffect(() => {
    const onPop = () => setRoute(parse(location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  const navigate = useCallback((r: Route) => {
    history.pushState(null, '', toPath(r));
    setRoute(r);
  }, []);
  const back = useCallback(() => {
    if (history.length > 1) history.back();
    else navigate({ name: 'catalog' });
  }, [navigate]);
  return { route, navigate, back };
}
